import React, { useState } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";
import PhoenixFormsV4Control from "./PhoenixFormsV4Control";
import PhoenixFormsV4ReadOnlyControl from "./PhoenixFormsV4ReadOnlyControl";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import PNXLabel from "./PNXLabel";
import { classes } from "components/Utility";


interface ReadOnlyProps {
  controlProps: controls.RepeatObject;
  parentControlProps: controls.RepeatControl;
}
interface Props extends ReadOnlyProps {
  deleteInstance: () => void;
  /** Pass through prop to ensure collapsible controls are uncollapsed when control is jumped to  */
  parentControlJump: () => void;
};

const PhoenixRepeatObject = ({
  controlProps,
  parentControlProps,
  deleteInstance,
  parentControlJump,
} : Props) => {

  const [collapsed, setCollapsed] = useState<boolean>(false);
  const [pendingDelete, setPendingDelete] = useState(false);

  /*
  full    - Repeat
  compact - Collapsible Repeat
  static  - Readonly Repeat
  */
  const appearance = parentControlProps.appearance ?? "full";

  const toggleCollapsed = () => {
    if (appearance !== "compact") return;

    setCollapsed(!collapsed);
  }

  let rootClassName = "repeat-object";

  if (appearance === "compact")
    rootClassName += " collapsible";

  if (collapsed)
    rootClassName += " collapsed";

  const onChildControlJump = () => {
    setCollapsed(false);
    parentControlJump();
  }

  const ButtonsRow = () => {
    if (parentControlProps.controls.length <= 1 || appearance === "static") return <span></span>;

    if (pendingDelete) {
      return (
        <>
          <Button onClick={deleteInstance} sx={{ marginRight: "8px" }}>Yes, Delete</Button>
          <Button color="secondary" onClick={() => setPendingDelete(false)}>Cancel</Button>
        </>
      );
    }
    else {
      return (<Button color="secondary" onClick={() => setPendingDelete(true)}>Delete</Button>);
    }
  };

  return <div className={rootClassName}>
    <div className="repeat-object-header">
      <div className="repeat-object-label" onClick={toggleCollapsed}>
        {appearance === "compact" &&
          <IconButton className={classes("md-collapser", !collapsed && "md-collapser--flipped")}>
            <Icon>keyboard_arrow_down</Icon>
          </IconButton>}
        <PNXLabel helpTopicId={controlProps.topicId} controlType="span">{`${parentControlProps.label} ${controlProps.repeatIndex}` }</PNXLabel>
      </div>
      <div>
        <ButtonsRow />
      </div>
    </div>
    <div className="repeat-object-controls">
      {controlProps.controls.map((child) => <PhoenixFormsV4Control key={`repeatobjectcontrol-${child.id}`} controlProps={child} onControlJump={onChildControlJump} />)}
    </div>
  </div>;
};

export const PhoenixRepeatObjectReadOnly = ({
  controlProps,
  parentControlProps,
} : ReadOnlyProps) => {

  return <div className="repeat-object">
    <div className="repeat-object-header">
      <div className="repeat-object-label">
        <PNXLabel controlType="span">{`${parentControlProps.label} ${controlProps.repeatIndex}` }</PNXLabel>
      </div>
    </div>
    <div className="repeat-object-controls">
      {controlProps.controls.map((child) => <PhoenixFormsV4ReadOnlyControl key={`repeatobjectcontrol-${child.id}`} controlProps={child} parentControlProps={controlProps} />)}
    </div>
  </div>;
};

export default PhoenixRepeatObject;